import React, { useState } from "react";
import { useSnackbar } from 'notistack';
import axios from 'axios'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Tooltip } from '@material-ui/core';
import { DeletePopUp, EmptyCollection, PageLoader } from '../../shared_elements'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import GetAppIcon from '@material-ui/icons/GetApp';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { globalDeleteService } from '../../../globalServices';
import { checkApiStatus, checkPermission } from '../../utils_v2';
import FilePreview from "../../shared_elements/FilePreview";
const NonTitledAssemblyAttachment = ({ nonTitledAssembliesAttachments, toggleModalFn, getResponseBack }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [deleteAttachment, setDeleteAttachment] = useState({ modal: false, data: null });
    const [previewModal, setPreviewModal] = useState({ open: false, data: null });
    const onDeleteAttachment = () => {
        setLoading(true)
        globalDeleteService(`console/attachments/${deleteAttachment.data.uuid}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    setDeleteAttachment({ modal: false, data: null });
                    getResponseBack(deleteAttachment.data.uuid);
                }
                setLoading(false)
            })
    }
    const onDownloadAttachment = (url, fileName) => {
        axios.get(url, { responseType: 'arraybuffer', })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click()
            })
            .catch(error => { })
    }
    return (
        <>
            <Dialog open={nonTitledAssembliesAttachments.modal} onClose={toggleModalFn} className='console-management-modal' maxWidth={'md'} fullWidth >
                <DialogTitle id="scroll-dialog-title"> Attachment(s) </DialogTitle>
                <DialogContent dividers={true} style={{ padding: '10px' }}>
                    <div style={{ minWidth: '400px' }} >
                        {nonTitledAssembliesAttachments?.data?.attachments?.length ?
                            <Paper style={{ padding: '10px' }}>
                                {nonTitledAssembliesAttachments.data.attachments.map((item, index) =>
                                    <div className="flex-centered" style={{ borderBottom: '1px solid #d7d7d7' }}>
                                        <p style={{ width: '80%' }} className="singleline-clamp"> {item.name}</p>
                                        <ul style={{ marginLeft: 'auto', cursor: 'pointer' }} className="list-inline">
                                            <li className="list-inline-item">
                                                <Tooltip title='View'><VisibilityIcon fontSize="small" color='primary' onClick={() => setPreviewModal({ open: true, data: item })} /></Tooltip>
                                            </li>
                                            <li className="list-inline-item">
                                                <Tooltip title='Download'><a onClick={() => onDownloadAttachment(item.url, item.name)} download={item.name}> <GetAppIcon fontSize="small" color='primary' /> </a></Tooltip>
                                            </li>
                                            {checkPermission('technical_specs', 'non_titled_assembly', 'D') ?
                                                <li className="list-inline-item">
                                                    <Tooltip title='Delete'><DeleteOutlineIcon onClick={() => setDeleteAttachment({ modal: true, data: item })} fontSize="small" color='secondary' /></Tooltip>
                                                </li> : null
                                            }
                                        </ul>
                                    </div>
                                )} </Paper> :
                            <div style={{ textAlign: 'center', padding: '15px 0' }}>
                                <EmptyCollection title='No Attachment Available' />
                            </div>
                        }
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={toggleModalFn} color="primary" size='small' variant="outlined">Close</Button>
                </DialogActions>
            </Dialog>
            {deleteAttachment.modal ?
                <DeletePopUp
                    modal={deleteAttachment.modal}
                    title='Delete Attachment'
                    content={`Are you sure, you want to Delete?`}
                    toggleModalFn={() => setDeleteAttachment({ modal: false, data: null })}
                    deleteRecordFn={onDeleteAttachment}
                /> : null
            }
            {previewModal.open && (
                <FilePreview
                    fileInfo={previewModal.data}
                    toggleModalFn={() => setPreviewModal({ open: false, data: null })}
                    downloadFile={(file) => onDownloadAttachment(file.url, file.name)}
                />
            )}
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default NonTitledAssemblyAttachment;